import { createAction, createReducer } from "redux-act";

import { reducerRegistry } from "../reducerRegistry";
import { FeatureDcExtended } from "../selectFeatures/types";
import { FeatureDataSource, PreviousFeatureReference, ShowFeatureState } from "./types";
import { LayerInfo } from "../../interfaces/resourceInfo";
import { SelectedFilters } from "../../modules/FeatureCard/types";

export const reducerName = "showFeature";

const initialState: ShowFeatureState = {
  searchString: "",
  page: 1,
  dataSources: null,
  dataSourceFilters: {},
  dataSourcesAreLoading: false,
};

export const reducer = createReducer({}, initialState);
export const setFeatureToShow = createAction<FeatureDcExtended | null>("showFeature/set-feature-to-show");
export const setLayerToShow = createAction<string>("showFeature/set-layer-to-show");
export const resetFeatureToShow = createAction("showFeature/reset-feature-to-show");
export const setSourceAttributeName = createAction<string>("showFeature/set-source-attribute-name");
export const setSourceLayerInfo = createAction<LayerInfo>("showFeature/set-source-layer-info");
export const setReferenceLayerInfos = createAction<LayerInfo[]>("showFeature/set-reference-layer-infos");
export const setPreviousFeatureReference = createAction<PreviousFeatureReference>("showFeature/set-previous-feature");
export const setFeatureSearchString = createAction<string>("showFeature/set-feature-search-string");
export const setFeatureDataSources = createAction<FeatureDataSource[]>("showFeature/set-data-sources");
export const setFeatureDataSourceFilters = createAction<SelectedFilters>("showFeature/set-data-source-filters");
export const setFeatureDataSourcesAreLoading = createAction<boolean>("showFeature/set-data-sources-are-loading");
export const setSelectedTabId = createAction<string>("showFeature/set-selected-tab-id");
export const setPage = createAction<number>("showFeature/set-page");
export const nextPage = createAction<number>("showFeature/next-page");
export const prevPage = createAction<number>("showFeature/prev-page");
export const changePage = createAction<number>("showFeature/change-page");

reducer.on(setFeatureToShow, (state, feature) => ({
  ...state,
  feature,
}));

reducer.on(setLayerToShow, (state, layerName) => ({
  ...state,
  layerName,
}));

reducer.on(setSourceAttributeName, (state, sourceAttributeName) => ({
  ...state,
  sourceAttributeName,
}));

reducer.on(setSourceLayerInfo, (state, sourceLayerInfo) => ({
  ...state,
  sourceLayerInfo,
}));

reducer.on(setReferenceLayerInfos, (state, referenceLayerInfos) => ({
  ...state,
  referenceLayerInfos,
}));

reducer.on(setPreviousFeatureReference, (state, previousFeatureReference) => ({
  ...state,
  previousFeatureReference,
}));

reducer.on(setFeatureSearchString, (state, searchString) => ({
  ...state,
  searchString,
}));

reducer.on(setFeatureDataSources, (state, dataSources) => ({
  ...state,
  dataSources,
}));

reducer.on(setFeatureDataSourceFilters, (state, dataSourceFilters) => ({
  ...state,
  dataSourceFilters,
}));

reducer.on(setFeatureDataSourcesAreLoading, (state, dataSourcesAreLoading) => ({
  ...state,
  dataSourcesAreLoading,
}));

reducer.on(setSelectedTabId, (state, selectedTabId) => ({
  ...state,
  selectedTabId,
}));

reducer.on(resetFeatureToShow, state => ({
  ...initialState,
  referenceLayerInfos: state.referenceLayerInfos,
}));

reducer.on(setPage, (state, page) => ({
  ...state,
  page,
}));

reducer.on(nextPage, (state, total) => ({
  ...state,
  page: state.page === total ? 1 : state.page + 1,
}));

reducer.on(prevPage, (state, total) => ({
  ...state,
  page: state.page === 1 ? total : state.page - 1,
}));

reducer.on(changePage, (state, page) => ({
  ...state,
  page,
}));

reducerRegistry.register(reducerName, reducer);
